export default __webpack_public_path__ + "static/media/loan-icon.67a68548.svg";